// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"63da7840","345":"2e09c2ba","568":"761e5244","610":"7ecf8eb7","667":"2c3e3ab7","789":"be38a008","884":"60ca0886"}[chunkId] + ".chunk.css";
};